import React from 'react'
import {
  ICON_NUMBER_OF_USES,
  ICON_CLOCK,
  ICON_TAG,
  ICON_SAVINGS,
  ICON_INSTORE,
  ICON_CHECKMARK
} from '../lib/client-constants'
import { compact } from 'lodash'

export type TagType =
  | 'OFFER_REDEMPTION_CHANNEL'
  | 'EXPIRATION_DATE'
  | 'PERCENT_CLAIMED'
  | 'LAST_SAVED'
  | 'NUM_OF_USES'
  | 'COUPON_CODE'
  | 'LAST_USED'

export interface Tag {
  text: string
  type: TagType
  className?: string
  priority?: number
}
export interface Label {
  text: string
  priority?: number
}

interface Props {
  className: string
  tags: Tag[] | null
}

const Tags = ({ className, tags }: Props) => {
  if (!tags || !tags.length) return null

  const labels = compact(
    tags.map(tag => {
      const icon = {
        NUM_OF_USES: ICON_NUMBER_OF_USES,
        EXPIRATION_DATE: ICON_CLOCK,
        LAST_SAVED: ICON_SAVINGS,
        COUPON_CODE: ICON_TAG,
        LAST_USED: ICON_CHECKMARK,
        OFFER_REDEMPTION_CHANNEL: ICON_INSTORE
      } as { [key: string]: string }

      if (!icon[tag.type] || !tag.text) return null
      return (
        <div key={tag.text} className={`label ${tag.className}`}>
          <img className="label--icon" src={icon[tag.type]} alt={tag.type} />
          <span className="label--text">{tag.text}</span>
        </div>
      )
    })
  )

  if (labels.length === 0) return null

  return <div className={className}>{labels}</div>
}

export default Tags
